import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'

// Import contexts
import { AuthProvider } from './contexts/AuthContext'
import { MedicationProvider } from './contexts/MedicationContext'
import { I18nProvider } from './contexts/I18nContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { CareProvider } from './contexts/CareContext'

// Initialize Firebase
import './config/firebase'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <I18nProvider>
          <AuthProvider>
            <CareProvider>
              <NotificationProvider>
                <MedicationProvider>
                  <App />
                </MedicationProvider>
              </NotificationProvider>
            </CareProvider>
          </AuthProvider>
        </I18nProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
) 